import Vue from 'vue'

/*  UNIVERSAL USER FEEDBACK
    ::: CLIFF :::
    One <NoticeSnackbar /> is mounted in App.vue and reads this state, so every page shows feedback the same way.

    Usage from any component:
        this.$feedback.success('Saved!')
        this.$feedback.error('Something went wrong.')
        this.$feedback.trigger(true, message, color, duration)   // same signature as the old triggerUserFeedback

    Colors are normalized to two looks. Anything in ERROR_COLORS is an error; everything else
    (light-green, success, primary, info, or no color) is a success.
*/

const ERROR_COLORS = ['accent', 'error', 'red']
const DEFAULT_DURATION = 6000

const state = Vue.observable({
    show: false,
    message: '',
    type: 'success',
    duration: DEFAULT_DURATION
})

const normalizeType = ( color ) => ERROR_COLORS.includes(String(color || '').toLowerCase()) ? 'error' : 'success'

const feedback = {
    state,

    show ( message, type = 'success', duration = DEFAULT_DURATION ) {
        // RE-OPEN EVEN IF A MESSAGE IS ALREADY SHOWING SO THE TIMEOUT RESTARTS
        state.show = false
        Vue.nextTick(() => {
            state.message = message
            state.type = type === 'error' ? 'error' : 'success'
            state.duration = Number(duration) || DEFAULT_DURATION
            state.show = true
        })
    },

    success ( message, duration ) {
        feedback.show(message, 'success', duration)
    },

    error ( message, duration ) {
        feedback.show(message, 'error', duration)
    },

    hide () {
        state.show = false
    },

    // DROP-IN FOR THE OLD triggerUserFeedback( feedback_trigger, feedback_message, feedback_color, feedback_duration )
    trigger ( feedback_trigger, feedback_message, feedback_color, feedback_duration ) {
        if ( !feedback_trigger ) return feedback.hide()
        feedback.show(feedback_message, normalizeType(feedback_color), feedback_duration)
    }
}

export default {
    install ( VueInstance ) {
        VueInstance.prototype.$feedback = feedback
    }
}

export { feedback }



// WEBPACK FOOTER //
// ./src/components/shared/feedback.js